import { Button, styled } from "@mui/material";
import useThemeStore from "@/shared/stores/useThemeStore";

export const GradientButton = styled(Button)(({ theme }) => {
  const { darkMode } = useThemeStore();
  return {
    background: darkMode
      ? "linear-gradient(90deg, var(--primary-700) 0%, var(--primary-400) 100%)"
      : "linear-gradient(90deg, #8E2DE2 0%, #4A00E0 100%)",
    color: darkMode ? "var(--neutralWhite)" : "var(--neutral-100)",
    font: "var(--semibold-md)",
    textTransform: "none",
    whiteSpace: "nowrap",
    borderRadius: "var(--spacing-3x)",
    padding: theme.spacing(1.4, 3),
    "&:hover": {
      background: darkMode
        ? "linear-gradient(90deg, var(--primary-400) 0%, var(--primary-700) 100%)"
        : "linear-gradient(90deg, #7329b3 0%, #3f00b2 100%)",
      boxShadow: "0 4px 14px rgba(138, 36, 235, 0.3)",
    },
  };
});